<div class="dropdown">

  <!-- Profile header -->
  <div class="profile-header">

    <!-- Avatar -->
    <div class="avatar-wrapper" (click)="triggerFileInput()" [class.uploading]="uploading" matRipple>
      <ng-container *ngIf="(userProfileService.profile$ | async) as profile">
        <img *ngIf="profile.photoUrl"
             [src]="profile.photoUrl"
             alt="Profile photo"
             class="avatar-img" />
        <div *ngIf="!profile.photoUrl" class="avatar-initials">
          {{ getInitials(profile) }}
        </div>
      </ng-container>
      <ng-container *ngIf="!(userProfileService.profile$ | async)">
        <div class="avatar-initials">
          <iconify-icon [icon]="icPerson" width="32" height="32"></iconify-icon>
        </div>
      </ng-container>

      <!-- Overlay shown on hover / while uploading -->
      <div class="avatar-overlay">
        <iconify-icon *ngIf="!uploading" [icon]="icCameraAlt" width="24" height="24"></iconify-icon>
        <span *ngIf="uploading" class="upload-spinner"></span>
      </div>
    </div>

    <!-- Hidden file input -->
    <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />

    <!-- Name & email -->
    <ng-container *ngIf="(userProfileService.profile$ | async) as profile">
      <div class="profile-name">{{ profile.name }}</div>
      <div class="profile-email">{{ profile.email }}</div>
    </ng-container>

    <!-- Upload error -->
    <div *ngIf="uploadError" class="upload-error">{{ uploadError }}</div>

    <!-- Change photo label -->
    <button class="change-photo-btn" (click)="triggerFileInput()" [disabled]="uploading" mat-button>
      {{ uploading ? 'Uploading…' : 'Change Photo' }}
    </button>

  </div>

  <div class="dropdown-actions">
    <button (click)="openGridCustomize()" color="primary" mat-button>
      <iconify-icon [icon]="icTune" width="18" height="18" class="mr-2"></iconify-icon>
      CUSTOMIZE GRID
    </button>
  </div>

  <div *ngIf="isAdmin" class="dropdown-actions">
    <button (click)="impersonate()" color="primary" mat-button>
      IMPERSONATE
    </button>
  </div>

  <!-- Footer -->
  <div class="dropdown-footer flex justify-center items-center">
    <a (click)="logout()" color="primary" mat-button>LOGOUT</a>
  </div>

</div>
